export default __webpack_public_path__ + "static/media/card-11.b25414e3.png";